import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true); // Start with loading true

  return (
    <UserContext.Provider
      value={{ userProfile, setUserProfile, loading, setLoading }}
    >
      {children}
    </UserContext.Provider>
  );
};
